<template>
  <div id="monthly-newsletters" class="module">
    <el-row class="flexbox flexbox__v-center">
      <el-col>
        <h1>Monthly Newsletters</h1>
      </el-col>

      <el-col class="page-tracker"
        >{{ currentPage }}/{{ Object.keys(uploadedNewsletters).length }}</el-col
      >

      <el-pagination
        background
        layout="prev, next"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </el-row>

    <el-card class="box-card">
      <newsletters
        v-for="(Newsletters, index) in uploadedNewsletters"
        v-show="currentPage === increment(index)"
        :key="increment(index)"
        :Newsletters="Newsletters"
      ></newsletters>
    </el-card>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  name: "MonthlyNewsletters",
  components: {
    Newsletters: () => import("@/components/Newsletters")
  },
  data() {
    return {
      currentPage: 1,
      uploadedNewsletters: [
        {
          2019: [
            "january",
            "february",
            "march",
            "april",
            "may",
            "june",
            "july",
            "august",
            "september"
          ]
        },
        {
          2018: [
            "march",
            "april",
            "may",
            "june",
            "july",
            "august",
            "september",
            "october",
            "november",
            "december"
          ]
        }
      ]
    };
  },
  computed: {
    orderedNewsletters() {
      //   return Object.keys(this.uploadedNewsletters).sort().reverse();
      return _(this.uploadedNewsletters)
        .toPairs()
        .sortBy(0)
        .reverse()
        .fromPairs()
        .value();
    }
  },
  methods: {
    increment(int) {
      return int + 1;
    },
    handleCurrentChange(val) {
      if (val <= Object.keys(this.uploadedNewsletters).length)
        this.currentPage = val;
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  font-size: 14px;
  color: #8a8a8a;
  letter-spacing: 0;
  line-height: 20px;
}

.page-tracker {
  font-weight: 700;
  font-size: 11px;
  color: rgba(144, 144, 144, 0.59);
  letter-spacing: 2px;
  text-align: right;
  line-height: 20px;
}
</style>
